import React from "react";

import TextControlContainer from "@/components/ControlContainer/TextControlContainer";

/**
 * 文本控制组件
 */
const Index: React.FC<{}> = () => {
  return <TextControlContainer />;
};

export default Index;
